import { Permission } from '@act/shared/authorization';
import { ActingUserDto, UserDto } from '@act/shared/data-transfer-objects';
import { checkPermissionOnMember } from 'redux/utils/auth/permissionChecks';

/**
 * Returns whether a member can participate in a bulk transfer request.
 *
 * @param member - Member considered for the bulk transfer.
 * @param actingUser - Current user who must be able to audit the transfer.
 * @returns True when the member has a guide and the user can audit the request.
 */
export function shouldSuggestBulkMemberTransfer(
  member: UserDto,
  actingUser: ActingUserDto | null | undefined
): boolean {
  if (!member?.assignedGuideId || !actingUser) {
    return false;
  }

  return checkPermissionOnMember({
    member,
    actingUser,
    permission: Permission.CAN_AUDIT_MEMBER_TRANSFER_REQUESTS,
  });
}
